// extracted by mini-css-extract-plugin
export default {"quillViewer":"QuillEditor_quillViewer__NkXcV"};